// extracted by mini-css-extract-plugin
module.exports = {"overflowText":"OverflowText_overflowText__nqX9F"};